import React from 'react'
import {defineMessages, useIntl} from 'react-intl'
import styled from '@emotion/styled'
import {ContentHotel, Hotel} from '@findhotel/sapi'

import {Icon} from '@vio/atlas/Icon'
import {Text} from '@vio/atlas/Text'
import {cssTheme} from '@vio/atlas/themes'

import {myListMessages} from '../../myListMessages'

// Keyed to match `myListMessages` so the two framings are interchangeable.
const alertMessages = defineMessages({
  toastAdded: {
    id: 'priceWatchToggle.enabledMessage',
    defaultMessage: 'You’re tracking prices at {hotel} {checkIn} - {checkOut}'
  },
  toastRemoved: {
    id: 'priceWatchToggle.disabledMessage',
    defaultMessage:
      'You’re no longer tracking prices at {hotel} {checkIn} - {checkOut}'
  }
})

const ToastWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
`

const IconWrapper = styled.div`
  padding-left: ${cssTheme.layout.spacing.s500};
`

export const PriceWatchToastMessage = ({
  enabled,
  hotel,
  checkIn,
  checkOut,
  shouldShowNavigationIcon,
  saveFramingIsOn
}: {
  hotel: ContentHotel | Hotel
  checkIn: string
  checkOut: string
  enabled: boolean
  shouldShowNavigationIcon?: boolean
  /** A prop, not a toggle read: some callers keep alert framing in both arms. */
  saveFramingIsOn?: boolean
}) => {
  const intl = useIntl()

  const values = {
    hotel: (
      <Text tag="span" variant="titleS">
        {hotel?.hotelName}
      </Text>
    ),
    checkIn: (
      <Text tag="span" variant="titleS">
        {intl.formatDate(new Date(checkIn), {
          day: 'numeric',
          month: 'short'
        })}
      </Text>
    ),
    checkOut: (
      <Text tag="span" variant="titleS">
        {intl.formatDate(new Date(checkOut), {
          day: 'numeric',
          month: 'short'
        })}
      </Text>
    )
  }

  const framing = saveFramingIsOn ? myListMessages : alertMessages
  const message = intl.formatMessage(
    enabled ? framing.toastAdded : framing.toastRemoved,
    values
  )

  // Scoped by hotel: toasts last 3s, so two quick toggles leave both in the DOM.
  const dataId = `PriceWatchToast-${hotel?.objectID}`

  return enabled && shouldShowNavigationIcon ? (
    <ToastWrapper data-id={dataId}>
      <span>{message}</span>
      <IconWrapper>
        <Icon size="md" name="ChevronRight" />
      </IconWrapper>
    </ToastWrapper>
  ) : (
    <span data-id={dataId}>{message}</span>
  )
}

export const PriceWatchToastIcon = ({enabled}: {enabled: boolean}) => (
  <Icon name={enabled ? 'BellRinging' : 'BellOff'} size="md" />
)
